module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeHolder":"Tap to search by Full Name or Case Number","noCase":"Can\u0027t find your case?"},"es":{"placeHolder":"Toque para buscar por nombre completo o n�mero de caso","noCase":"¿No puedes encontrar tu caso?"}}')
  delete Component.options._Ctor
}
